module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-backForm', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.full_screenFlag),
      expression: "full_screenFlag",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "name": 'back-taskTime',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backSet
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("等待接收时间")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.accept_time),
      expression: "accept_time"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "noVal number"
    },
    model: {
      value: (_vm.accept_time),
      callback: function($$v) {
        _vm.accept_time = $$v
      },
      expression: "accept_time"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("工作日")])], 2), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("超过时间则开具罚单")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7522e53e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/taskTime.vue
// module id = 764
// module chunks = 1